import http from '@/api/HttpHelper'

const state = {
    users: [],
    loading: false,
    loading_reset: false
}

const getters = {
    users (state) {
        return state.users
    },
    loading (state) {
        return state.loading
    },
    isLoadingReset (state) {
        return state.loading_reset
    }
}

const mutations = {
    fetchUsersResult (state, users) {
        state.users = users
    },
    setLoading (state, isLoading) {
        state.loading = isLoading
    },
    cleanUsers (state) {
        state.users = []
    },
    addUser (state, user) {
        state.users.push(user)
    },
    removeUser (state, user) {
        const index = state.users.indexOf(user)
        state.users.splice(index, 1)
    },
    setLoadingReset (state, isLoading) {
        state.loading_reset = isLoading
    }

}

const actions = {
    async getUsers ({ commit }) {
        commit('setLoading', true)

        try {
            const users = await http.get('useradministration')
            commit('fetchUsersResult', users.data)
        }
        catch (error) {
            commit('cleanUsers')
        }

        commit('setLoading', false)

    },
    async editUser({ dispatch }, user) {
        if (user.user_id) {
            await http.put(`useradministration/${user.user_id}`, user)
            dispatch('getUsers')
            
        } else {
            await http.post('useradministration', user)
            // commit('addUser', result.data)
            dispatch('getUsers')
        }
    },
    async deleteUser({ commit }, user) {
        await http.delete(`useradministration/${user.user_id}`)
        commit('removeUser', user)
    },
    async resetUserPassword({ commit }, user) {
        commit('setLoadingReset', true)
        await http.put(`password/reset/${user.user_id}`)
        commit('setLoadingReset', false)
        // console.log(JSON.stringify(result))

    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}